import useFetch from 'use-http';
import Utm from '~/utils/utm-tracking';

const useFormSubmit = ({ url, setIsSubmitted }) => {
  const isBrowser = typeof window !== 'undefined';

  // eslint-disable-next-line
  const { post, error, response, loading } = isBrowser ? useFetch(url) : {};

  return {
    error,
    response,
    loading,
    post: async (values) => {
      const pageUrl = isBrowser ? window.location.pathname : null;
      const utm = new Utm();

      let data = {
        ...values,
        ...utm.get(),
        pageUrl,
      };

      if (data.contact) {
        // Add autopilot session id
        if (!data.contact._autopilot_session_id) {
          data.contact._autopilot_session_id = window?.Autopilot?.sessionId;
        }

        if (typeof data.contact.Newsletter !== 'undefined') {
          data.contact.unsubscribed = !!!(data.contact.Newsletter === true);
        }
      }

      await post(data);

      if (response.ok === true) {
        setIsSubmitted(true);
      }

      if (typeof window?.dataLayer?.push !== 'undefined') {
        window.dataLayer.push({ event: 'form-submit', pageUrl });
      }
    },
  };
};

export default useFormSubmit;
